import { Action } from 'react-fetching-library';

export const getPostTranslationList: Action = {
  method: 'GET',
  endpoint: 'items/articles_translation',
};
